import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { CompanyModel } from 'views/AdminView/types';
import * as yup from 'yup';

const schema = yup
  .object({
    name: yup.string().trim().min(1).max(255).required(),
    handle: yup.string().trim().min(2).max(32).required(),
    tags: yup.array().of(yup.string().trim().min(1).max(255)).default([]),
    durations: yup
      .array()
      .of(yup.number().min(1).max(120).typeError('A number is required'))
      .default([10])
      .min(1)
      .max(10)
      .required(),
    description: yup
      .string()
      .trim()
      .optional()
      .nullable()
      .default(undefined)
      .transform((value) => (value === '' ? undefined : value)),
    image: yup.string().url().optional().nullable().default(undefined),
  })
  .required();

const useCompanyForm = (company?: CompanyModel) => {
  return useForm({
    resolver: yupResolver(schema),
    defaultValues: company || (schema.getDefault() as Partial<CompanyModel>),
  });
};

export default useCompanyForm;
